import { getQuestionnaireAnswers } from '../services/questionnaire';

const answersQuery = {
  key: 'answers',
  query: getQuestionnaireAnswers,
};

export { answersQuery };
